import { AHStatusCircle, useCircleSize, useTheme } from "arkh";
import { ImpactFeedbackStyle, impactAsync } from "expo-haptics";
import { Platform, TouchableOpacity, View } from "react-native";

import Color from "color";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { TodoCircleWidgetOverview_Todo$key } from "./__generated__/TodoCircleWidgetOverview_Todo.graphql";
import { useTodoCircleProps } from "./useTodoCircleProps";

// We got a view with overflow hidden around the status circle to prevent it from causing pressable issues on Android
export const TodoCircle = React.memo(
  (props: { onPress: () => void; todo: TodoCircleWidgetOverview_Todo$key }) => {
    const theme = useTheme();

    const { expireAt, createdAt, status } = useFragment(
      graphql`
        fragment TodoCircleWidgetOverview_Todo on Todo {
          expireAt
          createdAt
          status
        }
      `,
      props.todo
    );
    const { percentCompleted, isExpired } = useTodoCircleProps({
      expireAt,
      createdAt,
    });

    const size = useCircleSize("medium");
    return (
      <TouchableOpacity
        onPressIn={() => {
          if (Platform.OS === "ios") {
            impactAsync(ImpactFeedbackStyle.Medium);
          }
        }}
        onPress={props.onPress}
        pressRetentionOffset={{ left: 20, right: 20, top: 20, bottom: 20 }}
        hitSlop={{ left: 20, right: 20, top: 5, bottom: 5 }}
      >
        <View
          style={{ overflow: "hidden", height: size, width: size }}
          pointerEvents="none"
        >
          <AHStatusCircle
            filledColor={status === "DONE" ? theme.positive : theme.negative}
            shouldInsetFill
            icon={status === "DONE" ? "check" : undefined}
            progress={percentCompleted ?? 1}
            trackIsFilled={(percentCompleted ?? 1) === 1 || status === "DONE"}
            trackFillColor={isExpired ? theme.negative : theme.primary}
            isFilled={status === "DONE"}
            size={size}
            trackBackgroundColor={Color(theme.primary)
              .mix(Color(theme.surface), 0.6)
              .toString()}
          />
        </View>
      </TouchableOpacity>
    );
  }
);
